<template>
    <div class="dropdown">
        <a href="javascript:void(0)" class="share col text-center text-dark" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fal fa-share-alt"></i> Teilen
        </a>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a :href="whatsAppUrl" target="_blank" class="dropdown-item row">
                <i class="fab fa-whatsapp col-1"></i>
                <span class="col-11">WhatsApp</span>
            </a>
            <a :href="'sms:&body=' + this.url" target="_blank" class="dropdown-item row">
                <i class="fal fa-comment col-1"></i>
                <span class="col-11">SMS</span>
            </a>
            <a :href="fbMessengerUrl" target="_blank" class="dropdown-item row">
                <i class="fab fa-facebook-messenger col-1"></i>
                <span class="col-11">Facebook Messenger</span>
            </a>
            <a :href="facebookUrl" target="_blank" class="dropdown-item row">
                <i class="fab fa-facebook-f col-1"></i>
                <span class="col-11">Facebook</span>
            </a>
            <a :href="mailUrl" target="_blank" class="dropdown-item row">
                <i class="fal fa-envelope col-1"></i>
                <span class="col-11">E-Mail</span>
            </a>
            <a href="" class="dropdown-item row" v-on:click="copyToClipBoard">
                <i class="fal fa-link col-1"></i>
                <span class="col-11">Link kopieren</span>
            </a>
            <a :href="linkedinUrl" target="_blank" class="dropdown-item row">
                <i class="fab fa-linkedin-in col-1"></i>
                <span class="col-11">LinkedIn</span>
            </a>
            <a :href="twitterUrl" target="_blank" class="dropdown-item row">
                <i class="fab fa-twitter col-1"></i>
                <span class="col-11">Twitter</span>
            </a>
            <a :href="xingUrl" target="_blank" class="dropdown-item row">
                <i class="fab fa-xing col-1"></i>
                <span class="col-11">Xing</span>
            </a>
            <a :href="telegramUrl" target="_blank" class="dropdown-item row">
                <i class="fab fa-telegram-plane col-1"></i>
                <span class="col-11">Telegram</span>
            </a>
            <a :href="redditUrl" target="_blank" class="dropdown-item row">
                <i class="fab fa-reddit-alien col-1"></i>
                <span class="col-11">Reddit</span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ShareDropdown",
        props: ['url'],
        methods: {
            copyToClipBoard(){
                navigator.clipboard.writeText(this.url).then(function() {
                    console.warn("Link kopiert");
                }, function(err) {
                    console.warn(err.getMessage());
                });
            }
        },
        computed: {
            facebookUrl(){
                return "https://www.facebook.com/sharer.php?u=" + this.url
            },
            fbMessengerUrl(){
                return "fb-messenger://share/?link=" + this.url;
            },
            redditUrl(){
                return "https://reddit.com/submit?url=" + this.url + "&title=Schau dir dieses Auto auf faaren.com an"
            },
            twitterUrl(){
                return "https://twitter.com/intent/tweet?url=" + this.url + "&text=Autos abonnieren bei FAAREN&via=967317203916816384&hashtags=theyseemefaaren";
            },
            linkedinUrl(){
                return "https://www.linkedin.com/shareArticle?mini=true&url=" + this.url + "&title=Autos abonnieren bei FAAREN";
            },
            xingUrl(){
                return "https://www.xing.com/app/user?op=share&url=" + this.url;
            },
            telegramUrl(){
                return "tg://msg?url=" + this.url + "&text=Abonniere dein Auto bei FAAREN";
            },
            mailUrl(){
                return "mailto:?subject=Entdecke dein nächstes Auto bei FAAREN&body=" + this.url;
            },
            whatsAppUrl(){
                return "https://wa.me/?text=Schau dir dieses Auto bei FAAREN an " + this.url;
            }
        }
    }
</script>

<style scoped>

</style>